module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.is-object.js
 **/